ace.define("ace/snippets/json",["require","exports","module"],function(e,t,n){"use strict";t.snippetText=undefined,t.scope="json"})


//////////////////
// WEBPACK FOOTER
// ./~/brace/snippets/json.js
// module id = 170
// module chunks = 1